export default "__VITE_ASSET__cbc4379f__"